import React from "react";
import AvailabilityPreview from "./AvailabilityPreview";
import MobilityPreview from "./MobilityPreview";
import MotivationsPreview from "./MotivationsPreview";
import RemoteWorkPreview from "./RemoteWorkPreview";
import SalarialConditionPreview from "./SalarialConditionPreview";
import TypeOfPermitPreview from "./TypeOfPermitPreview";

const AvailabilityAndConditionsTabPreview = ({ interview }) => {
  return (
    <>
      <AvailabilityPreview interview={interview} />
      <MotivationsPreview interview={interview} />
      <MobilityPreview interview={interview} />
      <TypeOfPermitPreview permit={interview.permit} />
      <RemoteWorkPreview interview={interview} />
      <SalarialConditionPreview interview={interview} />
    </>
  );
};

export default AvailabilityAndConditionsTabPreview;
